export const DOC_WRAPPER_WIDTH_FOR_TWO_COLOMNS = 641;

export function checkIfTwoColomns(width: number): boolean {
  return width > DOC_WRAPPER_WIDTH_FOR_TWO_COLOMNS;
}
